// extracted by mini-css-extract-plugin
export var deleteModal = "_gh-0";